<!--
 * @Description: 
 * @Author: 凯欣
 * @Date: 2022-09-14 18:09:17
 * @LastEditTime: 2022-11-14 11:40:42
 * @LastEditors: 凯欣
 * @FilePath: \yongdian-pc\src\components\commentList.vue
 * kaixin
-->
<template>
  <div v-if="list.length > 0">
    <div class="">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="top">
          <span>{{ item.name }}</span>
          <div
            class="xingxing"
            :class="i < item.score ? 'active' : ''"
            v-for="(scoreItme, i) in 5"
            :key="i"
            v-if="item.score > 0"
          ></div>
        </div>
        <div class="mid">
          {{ item.content }}
        </div>
        <div class="img-box" v-if="item.imgUrl">
          <img
            v-for="(it, ind) in item.imgUrl.split(',')"
            :src="$imgUrl + it"
            :key="ind"
          />
        </div>
      </div>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-size="2"
      layout="total, prev, pager, next"
      :total="commentList.length"
      background
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageIndex: 1,
      list: [],
    };
  },
  props: ["commentList"],
  created() {
    // if (this.commentList.length > 0) {
    //   let list = [];
    //   let commonList = this.commentList;
    //   let number = parseInt(this.commentList.length / 2) + 1;
    //   for (var i = 0; i < number; i++) {
    //     list[i] = [];
    //     this.commentList.forEach((value, index) => {
    //       if (i * index < (i + 1) * 2 && list[i].length <= 2) {
    //         list[i].push(value);
    //       } else {
    //         list[i].
    //       }
    //     });
    //   }
    //   console.log(list);
    //   this.list = list;
    // }
    let list = [];
    let minNumber = 0;
    let maxNumber = 2;
    this.commentList.forEach((value, i) => {
      if (i >= minNumber && i < maxNumber) {
        list.push(value);
      }
    });
    this.list = list;
  },
  methods: {
    handleCurrentChange(index) {
      this.pageIndex = index;
      let list = [];
      let minNumber = index * 2 - 2;
      let maxNumber = index * 2;
      this.commentList.forEach((value, i) => {
        if (i >= minNumber && i < maxNumber) {
          list.push(value);
        }
      });
      this.list = list;
    },
    jump(id) {
      this.$router.push({
        path: "/ordinaryUser/shareDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  font-size: 16px;
  margin-bottom: 30px;

  .top {
    display: flex;

    span {
      margin-right: 20px;
      border-left: 4px solid #ffaa00;
      display: flex;
      height: 18px;
      align-items: center;
      padding-left: 10px;
    }
  }

  .mid {
    margin-top: 20px;
    min-height: 30px;
  }

  .img-box {
    margin-top: 20px;
    display: flex;

    img {
      width: 100px;
      height: 100px;
      margin-right: 20px;
    }
  }
}

.xingxing {
  width: 0.15rem;
  height: 0.15rem;
  margin-right: 0.06rem;
  background: url("../assets/image/star_2.png") no-repeat;
  background-size: 100% 100%;

  &.active {
    background: url("../assets/image/star_1.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
